// Copyright (c) 2016 Deere & Company

import EmissionsPartSearch, {getDefaultState as getEmissionsPartSearchDefaultState} from '../state/report';
import actions from '../../actions-list';

const updateEmissionsPartSearchReport = (state, action) =>
    EmissionsPartSearch.update(state, {
        $set: action.data
    });

const resetEmissionsPartSearchReport = state =>
    EmissionsPartSearch.update(state, {
        $set: getEmissionsPartSearchDefaultState()
    });

export default (state = getEmissionsPartSearchDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_EMISSIONS_PART_SEARCH_REPORT_SUCCESS]: updateEmissionsPartSearchReport,
        [actions.RESET_EMISSIONS_PART_SEARCH_REPORT]: resetEmissionsPartSearchReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/reducers/report.js